import React, { useState, useEffect, useRef } from 'react';
import { useRecoilState } from 'recoil';
import { userState } from '../../stores/atoms';
import { auth } from "../../actions/firebase";
import { awsInstance } from "../../actions/api";
import { addValidation } from '../../actions/utiles';
import { decrypt } from '../../actions/cipher';
import Loading from "./../Loading";

function AddAdmin({ isLogined, history, match }) {
	const encryptedEmail = match.params.id;
	const email = decrypt(encryptedEmail);
	const [, setUser] = useRecoilState(userState);
	const [password, setPassword] = useState('');
	const [passwordCheck, setPasswordCheck] = useState('');
	const [isPasswordValid, setIsPasswordValid] = useState(false);
	const [isPasswordCheckValid, setIsPasswordCheckValid] = useState(false);
	const [loading, setLoading] = useState(false);
	const passwordRef = useRef();
	const confirmPasswordRef = useRef();
	const submitButtonRef = useRef();
	
	useEffect(() => {
		if (isPasswordValid && isPasswordCheckValid) {
			submitButtonRef.current.disabled = false;
		} else {
			submitButtonRef.current.disabled = true;
		}
		// eslint-disable-next-line
	}, [isPasswordValid, isPasswordCheckValid]);

	if (isLogined) {
		setUser(null);
    	sessionStorage.removeItem('user');
	}

	const onFormSubmit = async event => {
		event.preventDefault();
		try {
			setLoading(true);
			await auth.createUserWithEmailAndPassword(email, password); // firebase 계정등록
			requestAPI();
		} catch (e) {
			if (e.code === 'auth/email-already-in-use') { // 이미 가입된 사람은 그냥 쓰도록
				// alert('이미 사용중인 이메일입니다.');
				requestAPI();
			} else {
				await auth.currentUser.delete();
				alert(e);
			}
		} finally {
			setLoading(false);
		}
	}

	const requestAPI = async () => {
		const params = new URLSearchParams({ encrypted_email: encryptedEmail });
		const { data } = await awsInstance.put(`business/admin?${params}`);

		if (data.code === 'SUCCESS') {
			alert('회원가입이 성공하였습니다.');
			history.push('/');
		} else {
			await auth.currentUser.delete();
			alert('회원가입이 실패하였습니다.');
		}
	};

	const onPasswordChange = event => {
		const password = event.target.value;
		setPassword(password);
		if (password.length >= 8) {
			setIsPasswordValid(true);
		} else {
			setIsPasswordValid(false);
		}
	};

	const onPasswordCheckChange = event => {
		const passwordCheck = event.target.value;
		setPasswordCheck(passwordCheck);
		if (password === passwordCheck) {
			setIsPasswordCheckValid(true);
		} else {
			setIsPasswordCheckValid(false);
		}
	};

	return (
		<>
			<div className="register">
				<h3>회원가입</h3>
				<p>
					아래 정보를 입력하여 회원가입을 완료해주세요.<br/>
				</p>
				<form className="register-form"
				 onSubmit={onFormSubmit}
				 >
					<div className="input-area">
						<label htmlFor="email">이메일</label>
						<input
							className="form-control mb-3 email"
							placeholder="이메일"
							value={email}
							readOnly
							/>
						<label htmlFor="password">비밀번호</label>
						<input
							className={`form-control mb-3 ${addValidation(password && isPasswordValid)}`}
							id="password"
							type="password"
							placeholder="비밀번호"
							value={password}
							maxLength="17"
							onChange={onPasswordChange}
							ref={passwordRef}
							required />
						<label htmlFor="passwordCheck">비밀번호 확인</label>
						<input
							className={`form-control mb-3 ${addValidation(passwordCheck && isPasswordCheckValid)}`}
							id="passwordCheck"
							type="password"
							placeholder="비밀번호 확인"
							value={passwordCheck}
							maxLength="17"
							onChange={onPasswordCheckChange}
							ref={confirmPasswordRef}
							required />
					</div>
					<button className="form-control btn btn-lg submit-btn active mt-4" type="submit" ref={submitButtonRef}>회원가입</button>
				</form>
			</div>
			<Loading loading={loading} /> 
		</>
	);
}

export default AddAdmin;
